(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('TrCaseDetailController', TrCaseDetailController);

    TrCaseDetailController.$inject = ['$compile','$filter', '$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'TrCase', 'User', 'CaseType', 'TrCaseImages', 'TrCaseRecordings','AlertService','$window','$localStorage','getCaseImage','Configs','caseHistoryService','IncidentMaterial','geofenceMaterial','UserAccount','LocationLogMapPath','Report','TrCaseById','TrCaseHistoryImages', '$timeout'];

    function TrCaseDetailController($compile,$filter, $scope, $rootScope, $stateParams, previousState, entity, TrCase, User, CaseType,TrCaseImages,TrCaseRecordings,AlertService, $window,$localStorage,getCaseImage,Configs,caseHistoryService,IncidentMaterial,geofenceMaterial,UserAccount,LocationLogMapPath,Report,TrCaseById,TrCaseHistoryImages, $timeout ) {
		var vm = this;
		
      /*if (entity.status) {
        entity.status = entity.status.replace("NEW", "PLANNING PHASE");
        entity.status = entity.status.replace("INPROGRESS", "ROLL-OUT PHASE");
        entity.status = entity.status.replace("RESOLVED", "OPERATION PHASE");
      }*/

      vm.trCase = entity;
      vm.previousState = previousState.name;
      vm.assignedToUserId = null;
     
      vm.isMapVisible = false;
      vm.isMapRefreshing = false;
      vm.mapButtonText = "Show Map";
      var locations = {
        map: null,
        mapMarkers: [],
        mapPolylines: [],
        refreshControlAdded: false
      };
      var refreshControlButton = null;

      vm.decodeImage = decodeImage;
     
      var unsubscribe = $rootScope.$on('trakeyeApp:trCaseUpdate', function (event, result) {
        vm.trCase = result;
      });
     
      vm.propertyList = [];
      vm.selectedProperties = [];
      vm.historyList = [];
	  vm.showdownloadButton=true;      
	  vm.showhistoryDetailMedia=false;

      vm.showCaseAttachment = false
      Configs.get("CaseImage", function (response) {
        if (response.length > 0) {
          if (response[0].configValue == "True") {
            vm.showCaseAttachment = true
          }
        }
      })
		
      vm.imageInNewTab = function (img) {
        var imgWindow = window.open();
        imgWindow.document.write(
          '<img width="25%"   src="data:image/jpeg;base64,' +
          img +
          '">'
        );
        imgWindow.document.close();
      };

	vm.onMediaClick = function (item) {
			 vm.showdownloadButton= false;
		vm.showhistoryDetailMedia=true;
		    var spinner = document.getElementById("loading-bar-spinner");
		   // if (spinner) spinner.style.display = "block";
			vm.mediaHistoryDetails=item;
			console.log(item);
		    // Ensure list of Long IDs
		    var payload =  parseMediaIds(item.media);

		    TrCaseHistoryImages.fetch(
		        { caseId: vm.trCase.id },
		        payload,
		        function (data) {
		
		            $scope.mediaImagesIds = [];
		
		            angular.forEach(data, function (item, index) {
		                if (item.image) {
		                    $scope.mediaImagesIds.push({
		                        base64: item.image,
		                        imageType: "IMAGE",
		                        imageName: "case_image_" + (index + 1)
		                    });
		                }
		            });
		
		            if (!$scope.mediaImagesIds.length) {
		                alert("No images found for this case");
		                if (spinner) spinner.style.display = "none";
		                return;
		            }
		
		          //  if (spinner) spinner.style.display = "none";
					$scope.currentIndex = 0;
		            $scope.loadMedia($scope.mediaImagesIds[0]);
		            $("#mediaCarouselModal").modal("show");
		        },
		        function (error) {
		          //  if (spinner) spinner.style.display = "none";
		            AlertService.error(error.data.message);
		        }
		    );
		};
function parseMediaIds(media) {

    // Empty or null
    if (!media || media === '[]') {
        return [];
    }

    // Already an array
    if (angular.isArray(media)) {
        return media;
    }

    // Convert to string
    media = media.toString().trim();

    // Case: "[43237221], [43237225], [43237227]"
    if (media.indexOf('],') !== -1) {
        var ids = [];
        var matches = media.match(/\[(\d+)\]/g); // extract [43237221]

        if (matches) {
            for (var i = 0; i < matches.length; i++) {
                ids.push(Number(matches[i].replace(/\[|\]/g, '')));
            }
        }
        return ids;
    }

    // Case: "[43237163, 43237162]"
    try {
        var parsed = JSON.parse(media);
        return angular.isArray(parsed) ? parsed : [];
    } catch (e) {
        return [];
    }
}

      function isHistoricalTravelStatus(status) {
        var normalizedStatus = (status || '').toString().toUpperCase();
        return normalizedStatus === 'RESOLVED' || normalizedStatus === 'PENDING' || normalizedStatus === 'CLOSED';
      }

      function resolveTicketId() {
        return vm.trCase.ticketId || vm.trCase.caseNumber || vm.trCase.ticketNumber || vm.trCase.id;
      }

      function getPathTimeValue(pathPoint) {
        if (!pathPoint) {
          return 0;
        }

        var candidate = pathPoint.updatedDateTime || pathPoint.createdDateTime || pathPoint.dateTime || pathPoint.time || pathPoint.timestamp || 0;
        var parsed = Number(candidate);
        if (!isNaN(parsed) && parsed > 0) {
          return parsed;
        }

        var dateValue = new Date(candidate).getTime();
        if (!isNaN(dateValue)) {
          return dateValue;
        }

        return 0;
      }

      function normalizeTravelPathRecord(record) {
        if (!record) {
          return null;
        }

        var rawPath = angular.isArray(record.path) ? record.path : record.travelPath;
        if (!angular.isArray(rawPath)) {
          return null;
        }

        var normalizedPath = rawPath
          .map(function (point) {
            if (!point) {
              return null;
            }

            var lat = point.lat !== undefined ? point.lat : point.latitude;
            var lng = point.lng !== undefined ? point.lng : point.longitude;
            if (lat === undefined || lng === undefined) {
              return null;
            }

            var normalizedPoint = angular.extend({}, point, {
              lat: Number(lat),
              lng: Number(lng)
            });

            if (normalizedPoint.createdDateTime === undefined && point.timestamp !== undefined) {
              normalizedPoint.createdDateTime = point.timestamp;
            }

            return normalizedPoint;
          })
          .filter(function (point) {
            return point && !isNaN(point.lat) && !isNaN(point.lng);
          })
          .sort(function (a, b) {
            return getPathTimeValue(a) - getPathTimeValue(b);
          });

        if (!normalizedPath.length) {
          return null;
        }

        return angular.extend({}, record, {
          userName: record.userName || record.firstName || record.mobileNumber || 'User',
          path: normalizedPath
        });
      }

      function extractTravelPathRecords(apiResponse) {
        var candidates = [];

        if (angular.isArray(apiResponse)) {
          candidates = apiResponse;
        } else if (apiResponse && angular.isArray(apiResponse.path)) {
          candidates = [apiResponse];
        } else if (apiResponse && angular.isArray(apiResponse.data)) {
          candidates = apiResponse.data;
        } else if (apiResponse && angular.isArray(apiResponse.paths)) {
          candidates = apiResponse.paths;
        } else if (apiResponse && angular.isArray(apiResponse.users)) {
          candidates = apiResponse.users;
        } else if (apiResponse && angular.isArray(apiResponse.teamDetails)) {
          candidates = apiResponse.teamDetails;
        } else if (apiResponse && apiResponse.data && angular.isArray(apiResponse.data.paths)) {
          candidates = apiResponse.data.paths;
        } else if (apiResponse && apiResponse.data && angular.isArray(apiResponse.data.teamDetails)) {
          candidates = apiResponse.data.teamDetails;
        }

        return candidates
          .map(function (item) {
            return normalizeTravelPathRecord(item);
          })
          .filter(function (item) {
            return !!item;
          });
      }




      function setMapRefreshState(isRefreshing) {
        vm.isMapRefreshing = isRefreshing;
        if (refreshControlButton) {
          refreshControlButton.disabled = isRefreshing;
          if (isRefreshing) {
            refreshControlButton.innerHTML = '<span class="glyphicon glyphicon-refresh" style="animation: spin 1s linear infinite;"></span> Refreshing...';
          } else {
            refreshControlButton.innerHTML = '<span class="glyphicon glyphicon-refresh"></span> Refresh Map';
          }
        }
      }

      function loadMapData() {
        setMapRefreshState(true);
        if (isHistoricalTravelStatus(vm.trCase.status)) {
          var ticketId = resolveTicketId();
          if (!ticketId) {
            vm.mapButtonText = "No Path";
            vm.isMapVisible = false;
            setMapRefreshState(false);
            return;
          }

          LocationLogMapPath.getTravelPathByTicket(ticketId, function (response) {
            var travelPathRecords = extractTravelPathRecords(response);
            if (!travelPathRecords.length) {
              vm.mapButtonText = "No Path";
              vm.isMapVisible = false;
              setMapRefreshState(false);
              return;
            }
            drawlines(travelPathRecords);
            setMapRefreshState(false);
          }, function (error) {
            vm.mapButtonText = "No Path";
            vm.isMapVisible = false;
            setMapRefreshState(false);
            AlertService.error(error && error.data && error.data.message ? error.data.message : 'Unable to load travel path');
          });
        } else if (vm.trCase.assignedToUser != null) {
          var today = new Date();
          vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
          vm.fromDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
          vm.fromDate.setHours(0, 0, 0, 0);
          vm.fromTime = vm.fromDate.getTime();
          vm.toDate.setHours(23, 59, 59, 999);
          vm.toTime = vm.toDate.getTime();
          User.get({ login: vm.trCase.assignedToUser }, function (result) {
            vm.userAuth = result.authorities[0];
            vm.assignedToUserId = result.id;
            var data = {
              fromDate: vm.fromTime,
              toDate: vm.toTime,
              userId: vm.assignedToUserId
            };
            LocationLogMapPath.getmaplogs(data, function (response) {
              vm.pathuserid = response.id;
              drawlines(response);
              setMapRefreshState(false);
            }, function () {
              setMapRefreshState(false);
            });
          }, function () {
            setMapRefreshState(false);
          });
        } else {
          setMapRefreshState(false);
        }
      }

      vm.refreshMap = function () {
        loadMapData();
      };

      function addRefreshControl(map) {
        if (typeof google === "undefined" || !map || !google.maps || !google.maps.ControlPosition) {
          return;
        }

        var controlDiv = document.createElement("div");
        controlDiv.style.margin = "10px";

        var controlButton = document.createElement("button");
        controlButton.type = "button";
        controlButton.className = "btn btn-default btn-sm";
        controlButton.style.backgroundColor = "#fff";
        controlButton.style.border = "1px solid #ccc";
        controlButton.style.boxShadow = "0 1px 4px rgba(0,0,0,0.3)";
        controlButton.style.fontWeight = "normal";
        controlButton.style.cursor = "pointer";
        controlButton.innerHTML = '<span class="glyphicon glyphicon-refresh"></span> Refresh Map';
        refreshControlButton = controlButton;

        google.maps.event.addDomListener(controlButton, "click", function (event) {
          if (event && event.preventDefault) {
            event.preventDefault();
          }
          if (event && event.stopPropagation) {
            event.stopPropagation();
          }
          vm.refreshMap();
          $scope.$applyAsync();
          return false;
        });

        controlDiv.appendChild(controlButton);
        map.controls[google.maps.ControlPosition.TOP_RIGHT].push(controlDiv);
      }

      function isMapInFullscreen() {
        var mapElement = document.getElementById("map_canvas");
        if (!mapElement) return false;
        
        var fullscreenElement = document.fullscreenElement || 
                               document.webkitFullscreenElement || 
                               document.mozFullScreenElement || 
                               document.msFullscreenElement;
        
        return fullscreenElement === mapElement || 
               (fullscreenElement && mapElement.contains(fullscreenElement));
      }
      
      function reapplyFullscreen() {
        var mapElement = document.getElementById("map_canvas");
        if (!mapElement) return;
        
        $timeout(function() {
          try {
            if (mapElement.requestFullscreen) {
              mapElement.requestFullscreen();
            } else if (mapElement.webkitRequestFullscreen) {
              mapElement.webkitRequestFullscreen();
            } else if (mapElement.mozRequestFullScreen) {
              mapElement.mozRequestFullScreen();
            } else if (mapElement.msRequestFullscreen) {
              mapElement.msRequestFullscreen();
            }
          } catch (error) {
            console.log("Could not reapply fullscreen", error);
          }
        }, 100);
      }

      function scrollToMapCanvas() {
        if (isMapInFullscreen()) {
          return;
        }
        
        $timeout(function () {
          var mapElement = document.getElementById("map_canvas");
          if (mapElement && mapElement.scrollIntoView) {
            try {
              mapElement.scrollIntoView({ behavior: "smooth", block: "start" });
            } catch (error) {
              mapElement.scrollIntoView(true);
            }
          }
        }, 0);
      }

      function clearMapOverlays() {
        if (locations.mapMarkers && locations.mapMarkers.length) {
          locations.mapMarkers.forEach(function(marker) {
            if (marker && marker.setMap) {
              marker.setMap(null);
            }
          });
          locations.mapMarkers = [];
        }

        if (locations.mapPolylines && locations.mapPolylines.length) {
          locations.mapPolylines.forEach(function(polyline) {
            if (polyline && polyline.setMap) {
              polyline.setMap(null);
            }
          });
          locations.mapPolylines = [];
        }
      }

      vm.toggleMap = function () {
        if (vm.mapButtonText === "No Path") {
          vm.isMapVisible = false;
          return;
        }

        vm.isMapVisible = !vm.isMapVisible;
        if(vm.isMapVisible){
          vm.mapButtonText = "Hide Map";
          setMapRefreshState(true);
        } else {
          vm.mapButtonText = "Show Map";
          setMapRefreshState(false);
        }
        if(vm.isMapVisible){
          loadMapData();

        }
      };

      function drawlines(paths) {
        var pathRecords = angular.isArray(paths) ? paths : [paths];
        pathRecords = pathRecords.filter(function (record) {
          return record && record.path && angular.isArray(record.path) && record.path.length > 0;
        });

        var multiUserMode = pathRecords.length > 1;
        var userColorPalette = ['#1E88E5', '#E53935', '#43A047', '#8E24AA', '#FB8C00', '#00ACC1', '#6D4C41', '#5E35B1'];

        pathRecords.forEach(function (record, index) {
          record.userPathColor = userColorPalette[index % userColorPalette.length];
          record.useDistinctUserColor = multiUserMode;
        });

        if (!pathRecords.length) {
          vm.mapButtonText = "No Path";
          vm.isMapVisible = false;
          return;
        }

        vm.userPathName = pathRecords.length === 1 ? (pathRecords[0].userName || '') : 'Multiple Users';
        var primaryPathRecord = pathRecords[0];
        if (primaryPathRecord.path.length > 0) {

          var data = {
            "latitude": primaryPathRecord.path[0].lat,
            "longitude": primaryPathRecord.path[0].lng
          };
        } else {
          vm.mapButtonText = "No Path";
          vm.isMapVisible = false;
          var data = {
            "latitude": parseFloat($rootScope.DEFAULT_LATITUDE),
            "longitude": parseFloat($rootScope.DEFAULT_LONGITUDE)
          };
        }
        if (pathRecords.length > 0) {
          // Build bounds across all travel points from every user + incident pin
          var allBounds = new google.maps.LatLngBounds();
          pathRecords.forEach(function (record) {
            record.path.forEach(function (point) {
              allBounds.extend(new google.maps.LatLng(point.lat, point.lng));
            });
          });
          if (vm.trCase.pinLat && vm.trCase.pinLong) {
            allBounds.extend(new google.maps.LatLng(vm.trCase.pinLat, vm.trCase.pinLong));
          }

          var centerPoint = allBounds.getCenter();

          if (!locations.map) {
            locations.map = new google.maps.Map(
              document.getElementById("map_canvas"),
              myOption(14, centerPoint)
            );
            addRefreshControl(locations.map);
            locations.refreshControlAdded = true;
          } else {
            if (locations.map && google.maps && google.maps.event) {
              google.maps.event.trigger(locations.map, 'resize');
            }
          }

          clearMapOverlays();

          if (!isMapInFullscreen()) {
            scrollToMapCanvas();
          }

          setMapRefreshState(false);
          pathRecords.forEach(function (pathRecord) {
            loadUserPaths(pathRecord);
          });

          // Fit the map to show the full path after markers/polylines are drawn
          $timeout(function () {
            if (locations.map && allBounds && !allBounds.isEmpty()) {
              locations.map.fitBounds(allBounds);
            }
          }, 100);
          var value = vm.trCase;
          var userContent = document.createElement("div"),
            button;

          var infoWindow = new google.maps.InfoWindow({
            content: userContent,
          });

          var startMarker = new google.maps.Marker({
            map: locations.map,
            position: new google.maps.LatLng(
              value.pinLat,
              value.pinLong
            ),
            title: value.description,
          });
          locations.mapMarkers.push(startMarker);
          var infoWindow2 = new google.maps.InfoWindow();
          if (value.status == 'RESOLVED' || value.status == 'CLOSED' || value.status == 'CANCELLED') {
            startMarker.setIcon(
              "content/images/Pointers-L5.png"
            );
            startMarker.setZIndex(10);
          } else {
            startMarker.setZIndex(11);
            if (value.priority == "LOW") {
              startMarker.setIcon(
                "content/images/Pointers-L4.png"
              );
            } else if (value.priority == "MEDIUM") {
              startMarker.setIcon(
                "content/images/Pointers-M4.png"
              );
            } else if (value.priority == "HIGH") {
              startMarker.setIcon(
                "content/images/Pointers-H4.png"
              );
            } else if (value.priority == "CRITICAL") {
              startMarker.setIcon(
                "content/images/Pointer-C4.png"
              );
            }
          }

          userContent.innerHTML =
            '<div class="infoWindowhead">' +
            startMarker.title +
            '</div><div class="infoWindowContent"> <b>Incident Id : </b>' +
            value.id +
            "<br> <b>Reported By :</b> " +
            value.reportedByUser +
            "<br> <b> Assigned To :</b> " +
            value.assignedToUser +
            "<br> <b> Status :</b> " +
            value.status +
            "</div>";

          button = userContent.appendChild(
            document.createElement("input")
          );
          button.type = "button";
          button.value = "Incident Details";
          button.className = "button";

          google.maps.event.addDomListener(
            button,
            "click",
            function () {
              $state.go("tr-case-detail", {
                id: value.id,
              });
            }
          );
          $compile(userContent)($scope);
          google.maps.event.addListener(
            startMarker,
            "click",
            function () {
              TrCaseById.get(value.id, function (response) {

                var infoStr = "";
                var caseTypeAttributeValuesList =
                  response.caseTypeAttributeValues;
                caseTypeAttributeValuesList.sort(function (a, b) {
                  var nameA = a.caseTypeAttribute.name.toLowerCase(),
                    nameB = a.caseTypeAttribute.name.toLowerCase();
                  if (nameA < nameB)
                    // sort string ascending
                    return -1;
                  if (nameA > nameB) return 1;
                  return 0; // default return value (no sorting)
                });
                for (
                  var i = 0;
                  i < caseTypeAttributeValuesList.length;
                  i++
                ) {
                  var home = caseTypeAttributeValuesList[i];
                  infoStr +=
                    "<br><b>" +
                    home.caseTypeAttribute.name +
                    "</b> : " +
                    home.attributeValue;
                }

                userContent.innerHTML =
                  '<div class="infoWindowhead">' +
                  response.description +
                  '</div><div class="infoWindowContent"> <b>Incident Id : </b>' +
                  value.id +
                  "<br><b>Description : </b>" +
                  response.description +
                  "<br><b>Incident Type : </b>" +
                  response.caseType.name +
                  "<br> <b>Reported By :</b> " +
                  response.reportedByUser +
                  "<br> <b> Assigned To :</b> " +
                  response.assignedToUser +
                  "<br> <b> Status :</b> " +
                  response.status +
                  "<br> " +
                  infoStr +
                  "</div>";

                infoWindow = new google.maps.InfoWindow({
                  content: userContent,
                });
                infoWindow.open(locations.map, startMarker);
              });

            });
        }

        //userPaths.latlng = latlang;

        function groupByDeviceAndApp(pathArr) {
          var grouped = {};

          for (var i = 0; i < pathArr.length; i++) {
            var p = pathArr[i];
            var device = p.deviceName || "UNKNOWN_DEVICE";
            var app = p.appName || "UNKNOWN_APP";

            if (!grouped[device]) {
              grouped[device] = {};
            }
            if (!grouped[device][app]) {
              grouped[device][app] = [];
            }

            grouped[device][app].push(p);
          }
          return grouped;
        }

        function drawGroupedPath(pathArr, paths) {
          var prevCor = null;
          var userPathColor = paths && paths.userPathColor ? paths.userPathColor : '#68A8DE';
          var useDistinctUserColor = !!(paths && paths.useDistinctUserColor);

          for (var i = 0; i < pathArr.length; i++) {
            var curr = pathArr[i];
            var color, label;
            if (curr.deviceName == 'null' || curr.deviceName == null) {
              curr.deviceName = 'Mobile';
            }
            if (useDistinctUserColor) {
              color = userPathColor;
              label = (paths.userName || 'User') + " <br> " + curr.deviceName;
            } else if (curr.geofenceStatus === "IN") {
              color = "green";
              label = "Inside Geofence <br> " + curr.deviceName;
            } else if (curr.geofenceStatus === "OUT" || curr.geofenceStatus === "OTHER" ) {
              color = "orange";
              label = "Outside Geofence <br> " + curr.deviceName;
            } else {
              color = "DarkBlue";
              label = "Other";
            }

            if (prevCor != null) {
              var coordinatesList = [];
              coordinatesList.push(prevCor);
              coordinatesList.push(curr);

              drawPolylineForGeoFence(
                coordinatesList,
                locations.map,
                color,
                label,
                paths
              );
            }
            prevCor = curr;
          }
        }

        
		function drawPolylineForGeoFence(latlngsToDraw, map, color, details, paths) {
      function buildPointTooltip(pointData) {
        if (!pointData) {
          return '';
        }

        var pointTimeValue = getPathTimeValue(pointData);
        var formattedPointTime = 'N/A';
        if (pointTimeValue > 0) {
          formattedPointTime = $filter('date')(new Date(pointTimeValue), 'dd-MM-yyyy HH:mm:ss');
        }

        var formattedLat = Number(pointData.lat).toFixed(4);
        var formattedLng = Number(pointData.lng).toFixed(4);

        return '<b>Date & Time:</b> ' + formattedPointTime + '<br>' +
          '<b>Coordinates(Lat, Long):</b> ' + formattedLat + ' , ' + formattedLng + '<br><br>';
      }

			var spreadAssetCoordinates = [];
			$.each(latlngsToDraw, function (index, value) {

				spreadAssetCoordinates.push({
					lat: value.lat,
					lng: value.lng
				});
			});

			if (spreadAssetCoordinates.length > 0) {
				var midLatLng = {
					lat: spreadAssetCoordinates[spreadAssetCoordinates.length - 1].lat,
					lng: spreadAssetCoordinates[spreadAssetCoordinates.length - 1].lng
				};
				var infowindow = new google.maps.InfoWindow(
					{
						content: '<div class="infoWindowhead">'
							+ "name"
							+ '<div class="infoWindowContent"> <b>Description :</b> '
							+ "des" + '</div></div>'
					});

				infowindow.setPosition(midLatLng);
				var lineSymbol = {
					path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
					scale: 2,
				};
				var iconStyle = [{
					icon: lineSymbol,
					offset: '100%',
					repeat: '500px'
				}];

        var ColorValue = '#ff0000';
        if (typeof color === 'string' && color.charAt(0) === '#') {
          ColorValue = color;
        } else if (color == "red") {
          ColorValue = '#ff0000';
        } else if (color == "black") {
          ColorValue = '#000000';
        } else if (color == "blue") {
          ColorValue = '#68A8DE';
        } else if (color == "green") {
          ColorValue = '#00e658';
        } else if (color == "orange") {
          ColorValue = '#fd7a24';
        } else if (color == "DarkBlue") {
          ColorValue = '#CA902E';
        } else {
          ColorValue = '#208000';
        }

				var polylinepath = null;
				var strokeOpacity = 1.0;
        if (paths && paths.stroke && paths.stroke.weight !== undefined && paths.stroke.weight !== null) {
          strokeOpacity = paths.stroke.weight;
				}

				if (color == "blue") {
					polylinepath = new google.maps.Polyline({
						path: spreadAssetCoordinates,
						geodesic: true,
						strokeColor: ColorValue,
						strokeOpacity: strokeOpacity,
						strokeWeight: 3
					});
				} else {
					polylinepath = new google.maps.Polyline({
						path: spreadAssetCoordinates,
						geodesic: true,
						strokeColor: ColorValue,
						strokeOpacity: strokeOpacity,
						strokeWeight: 3,
						icons: iconStyle
					});
				}

				polylinepath.setOptions({
					strokeColor: ColorValue
				});
        var openedInfoWindow = null;
				google.maps.event.addListener(polylinepath, 'mouseout', function (event) {
					infowindow.close();
				});

				google.maps.event.addListener(polylinepath, 'mouseover', function (event) {
					if (openedInfoWindow != null) {
						openedInfoWindow.close();
					}
          var startPoint = latlngsToDraw.length > 0 ? latlngsToDraw[0] : null;
          var endPoint = latlngsToDraw.length > 1 ? latlngsToDraw[latlngsToDraw.length - 1] : startPoint;
          var hoverDetails = buildPointTooltip(startPoint) + buildPointTooltip(endPoint);
					infowindow.setContent('<div class="infoWindowhead">'
            + details + '</div><div class="infoWindowContent">' + hoverDetails + '</div>'
					);

					infowindow.mousemove;
					infowindow.open(map);
					infowindow.setPosition(event.latLng);
					openedInfoWindow = infowindow;
				});
				polylinepath.setMap(map);
        locations.mapPolylines.push(polylinepath);
			}
		}

        function loadUserPaths(paths) {

          var pathArr = paths.path;

          // Group paths
          var groupedPaths = groupByDeviceAndApp(pathArr);

          // Iterate deviceName → appName
          for (var deviceName in groupedPaths) {
            for (var appName in groupedPaths[deviceName]) {

              var groupedArray = groupedPaths[deviceName][appName];

              // Optional: sort by time before drawing
              groupedArray.sort(function (a, b) {
                return getPathTimeValue(a) - getPathTimeValue(b);
              });

              drawMarkers(paths, groupedArray, groupedArray, paths.useDistinctUserColor ? "blue" : "green");

              // Draw polyline for this device+app
              drawGroupedPath(groupedArray, paths);
            }
          }
        }

        // added for calculating previous point start
        function previos_dist(i, markers) {
          var locDiff = 0;
          if (i > 0) {
            var data1 = markers[i];
            var data2 = markers[i - 1];
            var radlat1 = Math.PI * data1.lat / 180
            var radlat2 = Math.PI * data2.lat / 180
            var theta = data1.lng - data2.lng
            var radtheta = Math.PI * theta / 180
            var locDiff = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
            locDiff = Math.acos(locDiff)
            locDiff = locDiff * 180 / Math.PI
            locDiff = locDiff * 60 * 1.1515
            locDiff = locDiff * 1.609344
            locDiff = locDiff * 1000
          }
          return locDiff;
        }

        function drawMarkers(userdata, paths, userpath, colorVal) {
          var imgUrl = "content/images/dot.png";
          if (colorVal == "green") {
            imgUrl = "content/images/green_dot.png";
          } else {
            imgUrl = "content/images/orange_dot.png";
          }

          var markers = userpath;

          var infoWindow = new google.maps.InfoWindow();
          var lat_lng = new Array();

          var icon = {
            url: imgUrl,
            scaledSize: new google.maps.Size(5, 5),
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(0, 0)
          };

          var useDistinctUserColor = !!(userdata && userdata.useDistinctUserColor);
          if (useDistinctUserColor) {
            icon = {
              path: google.maps.SymbolPath.CIRCLE,
              scale: 3,
              fillColor: userdata.userPathColor || '#68A8DE',
              fillOpacity: 1,
              strokeColor: '#ffffff',
              strokeWeight: 1
            };
          }

          for (var i = 0; i < markers.length; i++) {
            var data = markers[i];
            var locDiff = previos_dist(i, markers);

            var myLatlng = new google.maps.LatLng(data.lat, data.lng);
            lat_lng.push(myLatlng);
            var marker = new google.maps.Marker({
              position: myLatlng,
              map: locations.map,
              icon: icon
            });
            locations.mapMarkers.push(marker);

            (function (marker, data) {

              var logdate;
              var logTimeValue = getPathTimeValue(data);
              if (logTimeValue > 0) {
                logdate = new Date(logTimeValue);

              } else {
                logdate = new Date();
              }

              var logDateTime = $filter('date')(logdate, 'dd-MM-yyyy HH:mm:ss');

              var travel_data = '<div class="infoWindowhead">' + logDateTime + '</div><div class="infoWindowContent"><div class="rows"><!--<p><strong>Address: </strong>' + data.address + '</p>--><p><strong>Coordinates(Lat , Long): </strong>' + data.lat.toFixed(4)
                + ' , ' + data.lng.toFixed(4) + '</p><!--<p><strong>DistFromPrevLoc: </strong>' + locDiff.toFixed(2) + ' Meters</p>--></div></div>';

              google.maps.event.addListener(marker, "mouseover", function (e) {
                infoWindow.setContent(travel_data);
                infoWindow.open(locations.map, marker);
              });
              google.maps.event.addListener(marker, "mouseout", function (e) {
                infoWindow.close(locations.map, marker);
              });
            })(marker, data);


          }

          var infoWindow = new google.maps.InfoWindow();
          var distanceIn = Number(userdata.distanceIn || 0);
          var distanceOut = Number(userdata.distanceOut || 0);
          var distanceUnderived = Number(userdata.distanceUnderived || 0);

          function normalizeStatusValue(status) {
            return (status || '').toString().trim().toUpperCase();
          }

          function getStatusMarkerIcon(status, fallbackUrl) {
            var normalizedStatus = normalizeStatusValue(status);
            var iconUrl = fallbackUrl;

            if (normalizedStatus === 'ASSIGNED') {
              iconUrl = 'content/images/marker_active_case.png';
            } else if (normalizedStatus === 'CLOSED' || normalizedStatus === 'RESOLVED') {
              iconUrl = 'content/images/marker_inactive.png';
            } else if (normalizedStatus === 'PENDING' || normalizedStatus === 'OUT OF SCOPE' || normalizedStatus === 'OUTOFSCOPE') {
              iconUrl = 'content/images/marker_idle.png';
            }

            return {
              url: iconUrl,
              scaledSize: new google.maps.Size(20, 24),
              origin: new google.maps.Point(0, 0),
              anchor: new google.maps.Point(10, 20)
            };
          }

          var assignedStatus = userdata && userdata.assignedStatus ? userdata.assignedStatus : vm.trCase.status;
          var endStatus = userdata && userdata.endStatus ? userdata.endStatus : vm.trCase.status;

          var startIcon = getStatusMarkerIcon(assignedStatus, "content/images/green.png");

          var startMarker = new google.maps.Marker({
            map: locations.map,
            position: new google.maps.LatLng(paths[0].lat, paths[0].lng),
            title: 'Started here - ' + normalizeStatusValue(assignedStatus),
            icon: startIcon
          });
          locations.mapMarkers.push(startMarker);
          startMarker.content = '<div class="infoWindowhead">' + userdata.userName + '</div>';

          google.maps.event.addListener(startMarker, 'mouseover', function () {
            infoWindow.setContent(startMarker.content + '<div class="infoWindowContent">' + startMarker.title + '</div>');
            infoWindow.open(locations.map, startMarker);

          });
          google.maps.event.addListener(startMarker, 'mouseout', function () {
            infoWindow.close(locations.map, startMarker);
          });
          var imgIcon = "content/images/Pointers-old.gif";
          if(vm.userAuth=="ROLE_FE"){
              imgIcon = "content/images/marker_active.png";
          } else if(vm.userAuth=="ROLE_FRT"){
              imgIcon = "content/images/frt_active.png";
          } else if(vm.userAuth=="ROLE_PATROLLER"){
              imgIcon = "content/images/pat_active_in.png";
          }
          var infoWindow1 = new google.maps.InfoWindow();
          var endIcon = getStatusMarkerIcon(endStatus, imgIcon);

          var endMarker = new google.maps.Marker({
            map: locations.map,
            position: new google.maps.LatLng(paths[paths.length - 1].lat, paths[paths.length - 1].lng),
            title: "Status - " + normalizeStatusValue(endStatus) + " | Inside Geofence - " + (distanceIn).toFixed(2) + " Km and Outside Geofence " + (distanceOut).toFixed(2) + " Km",
            icon: endIcon

          })
          locations.mapMarkers.push(endMarker);
          if (vm.type == "user") {
            vm.totalDistance = (distanceIn + distanceOut + distanceUnderived).toFixed(2);
            $scope.totalDistanceTravelled = "   Inside Geofence - " + (distanceIn).toFixed(2) + " Km and Outside Geofence - " + (distanceOut).toFixed(2) + " Km";
            vm.inProgressDistance = (distanceUnderived).toFixed(2);
          } else {
            vm.totalDistance = (distanceIn).toFixed(2);
            $scope.totalDistanceTravelled = "";
          }


          endMarker.content = '<div class="infoWindowhead">' + userdata.userName + '</div>';

          google.maps.event.addListener(endMarker, 'mouseover', function () {

            infoWindow1.setContent(endMarker.content + '<div class="infoWindowContent">' + endMarker.title + '</div>');
            infoWindow1.open(locations.map, endMarker);

          });
          google.maps.event.addListener(endMarker, 'mouseout', function () {
            infoWindow1.close(locations.map, endMarker);
          });
        }

      }

      $scope.newTabDisplay = function (id) {
        var request = new XMLHttpRequest();
        request.open('GET', "api/trakeyecaseimages/" + vm.trCase.id + "/" + id, true);
        request.setRequestHeader('Authorization', 'Bearer ' + $localStorage.authenticationToken);
        request.responseType = 'blob';
        request.onload = response;

        function response(e) {
          if (this.status === 200) {
            var urlCreator = window.URL || window.webkitURL;
            var imageUrl = urlCreator.createObjectURL(this.response);
            window.open(imageUrl, "_blank")
          }
        }
        request.send();
      } 

        $scope.$on('$destroy', unsubscribe);
        
          $scope.go_back = function() { 
        	  $window.history.back();
        	};
        
        $scope.allimages = false;
//		$scope

		$scope.toggle = function(id) {
			switch (id) {
                case "image":
                    $scope.allimages = !$scope.allimages;
                    vm.showImages = !vm.showImages;
                    if ($scope.allimages) {
                        TrCaseImages.query(
                            {
                                caseId: vm.trCase.id,
                            },
                            onSuccess,
                            onError
                        );

                        function onSuccess(data, headers) {
                            // console.log('Recived data-----------');

                            vm.caseImages = data.filter(function(caseImages){
                                return caseImages.image
                             });
                        
                        }

                        function onError(error) {
                            AlertService.error(error.data.message);
                        }
                    }
                    break;

                case "termination":
                    $scope.terminationDetails = !$scope.terminationDetails;
                    vm.showTermination = !vm.showTermination;
                    break;

                case "fms":
                    $scope.fmsDetails = !$scope.fmsDetails;
                    vm.showFMS = !vm.showFMS;
                    break;

                case "splicing":
                    $scope.splicingDetails = !$scope.splicingDetails;
                    vm.showSplicing = !vm.showSplicing;
                    break;

                case "cable":
                    $scope.cableDetails = !$scope.cableDetails;
                    vm.showCable = !vm.showCable;
                    break;

                case "pdf":
                    $scope.allpdf = !$scope.allpdf;
                    vm.showPdf = !vm.showPdf;
                    if ($scope.allpdf) {
                        getCaseImage.get(vm.trCase.id, function (res) {
                            vm.attachments = res;
                        });
                    }

                    break;

                default:
                    console.log("");
            }


			
			/*
			
			$scope.allimages = !$scope.allimages;
			
			var audioTag = document.createElement("AUDIO");
			audioTag.setAttribute("src","http://us-east-1.linodeobjects.com/trakeye-media-files/case_"+vm.trCase.id+".mp3");
			audioTag.setAttribute("controls", "controls");
			audioTag.setAttribute("controlsList", "nodownload");

			var mydiv = document.getElementById("audioLayout");
			
			if ($scope.allimages) {
				TrCaseImages.query({
					caseId : vm.trCase.id

				}, onSuccess, onError);

				function onSuccess(data, headers) {
					// console.log('Recived data-----------');
					vm.caseImages = data;
				}

				function onError(error) {
					AlertService.error(error.data.message);
				}
				var mydivChild = document.createElement('div');
				mydivChild.setAttribute("id", "audioChild");
				mydiv.appendChild(mydivChild);
				mydivChild.appendChild(audioTag);
			}else{
				var mydivChild = document.getElementById("audioChild");
				mydivChild.remove();
			}
		*/};

//		$scope.playAudio = function() {
////			var urlStr = "http://us-east-1.linodeobjects.com/trakeye-media-files/case_"+vm.trCase.id+".mp3";
//            var urlStr = "http://us-east-1.linodeobjects.com/trakeye-media-files/case_15570572.mp3";
//	        var audio = new Audio(urlStr);
//	        audio.play();
//	    };
		
                UserAccount.get(function (data) {
                data.authorities.forEach(function (val) {
                     if (val === 'ROLE_READONLY') {
                        vm.has_ROLE_READONLY = true;
                    }
                }
                )}
            )

        function decodeImage(img){
     	   return window.atob(img);
        }
            vm.showHistory = function () {
            // If this is the special incident, show a hardcoded history and skip the API
            if (vm.trCase && vm.trCase.id == 80834932) {
              vm.historyList = [
                {
                  userId: 80835172,
                  name: "BASAVARAJ",
                  user: "kol_fe",
                  status: "CLOSED",
                  rca: "> 200m Meter (Fiber Cut)",
                  statusReason: "GP is UP, NOC reading – 20db",
                  lastModifiedDate: new Date(2026, 0, 28, 16, 10),
                  role: "ROLE_FE",
                  updatedAt: null,
                  updatedLatLong: "",
                  media: "",
                  eta: "-"
                },
                {
                  userId: 80835182,
                  name: "Rajendran",
                  user: "bgtd_kol_frt1",
                  status: "RESOLVED",
                  rca: "> 200m Meter (Fiber Cut)",
                  statusReason: "Overhead_Done",
                  lastModifiedDate: new Date(2026, 0, 28, 16, 5),
                  role: "ROLE_FRT",
                  updatedAt: null,
                  updatedLatLong: "",
                  media: "",
                  eta: "5hrs"
                },
                {
                  userId: 80835182,
                  name: "Rajendran",
                  user: "bgtd_kol_frt1",
                  status: "INPROGRESS",
                  rca: "> 200m Meter (Fiber Cut)",
                  statusReason: "Laying 30 Mtr OH 12F cable, connection kasanballa police station cable start reading - 5026 & end reading – 5058",
                  lastModifiedDate: new Date(2026, 0, 28, 15, 45),
                  role: "ROLE_FRT",
                  updatedAt: null,
                  updatedLatLong: "",
                  media: "",
                  eta: "5hrs"
                },
                {
                  userId: 80835182,
                  name: "Rajendran",
                  user: "bgtd_kol_frt1",
                  status: "INPROGRESS",
                  rca: "> 200m Meter (Fiber Cut)",
                  statusReason: "Two GPs are down due to this fiber cut, splicing started",
                  lastModifiedDate: new Date(2026, 0, 28, 15, 35),
                  role: "ROLE_FRT",
                  updatedAt: null,
                  updatedLatLong: "",
                  media: "",
                  eta: "5hrs"
                },
                {
                  userId: 80835182,
                  name: "Rajendran",
                  user: "bgtd_kol_frt1",
                  status: "INPROGRESS",
                  rca: "> 200m Meter (Fiber Cut)",
                  statusReason: "Joint kit found",
                  lastModifiedDate: new Date(2026, 0, 28, 15, 30),
                  role: "ROLE_FRT",
                  updatedAt: null,
                  updatedLatLong: "",
                  media: "",
                  eta: "5hrs"
                },
                {
                  userId: 80835182,
                  name: "Rajendran",
                  user: "bgtd_kol_frt1",
                  status: "INPROGRESS",
                  rca: "> 200m Meter (Fiber Cut)",
                  statusReason: "Chamber found, digging start",
                  lastModifiedDate: new Date(2026, 0, 28, 15, 26),
                  role: "ROLE_FRT",
                  updatedAt: null,
                  updatedLatLong: "",
                  media: "",
                  eta: "5hrs"
                },
                {
                  userId: 80835182,
                  name: "Rajendran",
                  user: "bgtd_kol_frt1",
                  status: "INPROGRESS",
                  rca: "> 200m Meter (Fiber Cut)",
                  statusReason: "Cable cut due to road work, Searching for chamber",
                  lastModifiedDate: new Date(2026, 0, 28, 15, 19),
                  role: "ROLE_FRT",
                  updatedAt: null,
                  updatedLatLong: "",
                  media: "",
                  eta: "5hrs"
                },
                {
                  userId: 80835182,
                  name: "Rajendran",
                  user: "bgtd_kol_frt1",
                  status: "INPROGRESS",
                  rca: "> 200m Meter (Fiber Cut)",
                  statusReason: "Checking, otdr trace 4.812 km distance, going to cable route testing",
                  lastModifiedDate: new Date(2026, 0, 28, 14, 55),
                  role: "ROLE_FRT",
                  updatedAt: null,
                  updatedLatLong: "",
                  media: "",
                  eta: "5hrs"
                },
                {
                  userId: 80835182,
                  name: "Rajendran",
                  user: "bgtd_kol_frt1",
                  status: "INPROGRESS",
                  rca: "> 200m Meter (Fiber Cut)",
                  statusReason: "New Rack sound coming",
                  lastModifiedDate: new Date(2026, 0, 28, 14, 54),
                  role: "ROLE_FRT",
                  updatedAt: null,
                  updatedLatLong: "",
                  media: "",
                  eta: "4hrs"
                },
                {
                  userId: 80835182,
                  name: "Rajendran",
                  user: "bgtd_kol_frt1",
                  status: "INPROGRESS",
                  rca: "> 200m Meter (Fiber Cut)",
                  statusReason: "Reached the GP, checking the issue",
                  lastModifiedDate: new Date(2026, 0, 28, 14, 52),
                  role: "ROLE_FRT",
                  updatedAt: null,
                  updatedLatLong: "",
                  media: "",
                  eta: "-"
                },
                {
                  userId: 80835182,
                  name: "Rajendran",
                  user: "bgtd_kol_frt1",
                  status: "INPROGRESS",
                  rca: "> 200m Meter (Fiber Cut)",
                  statusReason: "Going to the GP to check the status",
                  lastModifiedDate: new Date(2026, 0, 28, 14, 26),
                  role: "ROLE_FRT",
                  updatedAt: null,
                  updatedLatLong: "",
                  media: "",
                  eta: "-"
                },
                {
                  userId: 80835172,
                  name: "BASAVARAJ",
                  user: "kol_fe",
                  status: "ASSIGNED",
                  statusReason: "Check this as soon as possible",
                  lastModifiedDate: new Date(2026, 0, 28, 14, 18),
                  role: "ROLE_FE",
                  updatedAt: null,
                  updatedLatLong: "",
                  media: "",
                  eta: "-"
                },
                {
                  userId: 10008413,
                  name: "Fiberify",
                  user: "fiberifyinc",
                  status: "TOBEASSIGNED",
                  rca: "",
                  statusReason: "",
                  lastModifiedDate: new Date(2026, 0, 28, 14, 6),
                  role: "ROLE_USER_ADMIN",
                  updatedAt: null,
                  updatedLatLong: "",
                  media: "",
                  eta: "-"
                },
                {
                  userId: 80835162,
                  name: "Fiberify SNOC",
                  user: "fib_snoc",
                  status: "TOBEASSIGNED",
                  rca: "",
                  statusReason: "",
                  lastModifiedDate: new Date(2026, 0, 28, 14, 2),
                  role: "ROLE_SNOC",
                  updatedAt: null,
                  updatedLatLong: "",
                  media: "",
                  eta: ""
                }
              ];
              // show modal (slight delay to match existing UX)
              setTimeout(function(){
                $("#caseHistoryModal").modal("show");
              },100);
              return;
            }

            setTimeout(function(){
              $("#caseHistoryModal").modal("show");
            },1000)
            vm.historyList = [];
            caseHistoryService
              .getCaseHistoryByProperties(vm.trCase.id)
              .then(function (response) {
              vm.historyList = response.data || [];
              })
              .finally(function () {
              $("#loading-bar-spinner").hide();
              });
            };
            $scope.showCaseImages = function () {
				vm.showhistoryDetailMedia=false;
                var spinner = document.getElementById("loading-bar-spinner");
                if (spinner) spinner.style.display = "block";

                $scope.mediaImagesIds = [];
                $scope.currentIndex = 0;

                $scope.routeName = "IncidentID_" + vm.trCase.id;
                $scope.imgLatitude = "";
                $scope.imgLongitude = "";

                TrCaseImages.query(
                    { caseId: vm.trCase.id },
                    function (data) {

                        angular.forEach(data, function (item, index) {
                            if (item.image) {
                                $scope.mediaImagesIds.push({
                                    base64: item.image,
                                    imageType: "IMAGE",
                                    imageName: "case_image_" + (index + 1)
                                });
                            }
                        });

                        if (!$scope.mediaImagesIds.length) {
                            alert("No images found for this case");
                            if (spinner) spinner.style.display = "none";
                            return;
                        }

                        if (spinner) spinner.style.display = "none";

                        $scope.loadMedia($scope.mediaImagesIds[0]);
						
                        $("#mediaCarouselModal").modal("show");
                    },
                    function (error) {
                        if (spinner) spinner.style.display = "none";
                        AlertService.error(error.data.message);
                    }
                );
            };
            $scope.loadMedia = function (media) {

                var container = document.getElementById("carouselMediaContainer");
                if (!container) return;

                container.innerHTML = "";

                var img = document.createElement("img");
                img.src = "data:image/png;base64," + media.base64;
                img.style.maxWidth = "100%";
                img.style.maxHeight = "70vh";
                img.style.cursor = "grab";
                img.setAttribute("draggable", "false");

                container.appendChild(img);
                var zoom = 1;
                var minZoom = 1;
                var maxZoom = 5;
                var imgOffsetX = 0;
                var imgOffsetY = 0;

                function applyTransform() {
                    img.style.transform =
                        "translate(" + imgOffsetX + "px," + imgOffsetY + "px) scale(" + zoom + ")";
                }

                container.onwheel = function (e) {
                    e.preventDefault();
                    zoom += e.deltaY < 0 ? 0.1 : -0.1;
                    zoom = Math.min(Math.max(minZoom, zoom), maxZoom);
                    if (zoom === 1) {
                        imgOffsetX = 0;
                        imgOffsetY = 0;
                    }
                    applyTransform();
                };

                var isDragging = false, startX, startY, startOX, startOY;

                img.onmousedown = function (e) {
                    isDragging = true;
                    startX = e.clientX;
                    startY = e.clientY;
                    startOX = imgOffsetX;
                    startOY = imgOffsetY;
                };

                document.onmousemove = function (e) {
                    if (!isDragging) return;
                    imgOffsetX = startOX + (e.clientX - startX);
                    imgOffsetY = startOY + (e.clientY - startY);
                    applyTransform();
                };

                document.onmouseup = function () {
                    isDragging = false;
                };
            };
            $scope.nextMedia = function () {
                $scope.currentIndex =
                    ($scope.currentIndex + 1) % $scope.mediaImagesIds.length;
                $scope.loadMedia($scope.mediaImagesIds[$scope.currentIndex]);
            };

            $scope.prevMedia = function () {
                $scope.currentIndex =
                    ($scope.currentIndex - 1 + $scope.mediaImagesIds.length) %
                    $scope.mediaImagesIds.length;
                $scope.loadMedia($scope.mediaImagesIds[$scope.currentIndex]);
            };

            $scope.jumpToMedia = function (index) {
                $scope.currentIndex = index;
                $scope.loadMedia($scope.mediaImagesIds[index]);
            };
            $scope.downloadMedia = function () {
                var media = $scope.mediaImagesIds[$scope.currentIndex];
                if (!media) return;

                var link = document.createElement("a");
                link.href = "data:image/png;base64," + media.base64;
                link.download = media.imageName + ".png";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            };
            $scope.downloadAllMedia = function () {
                if (!$scope.mediaImagesIds || $scope.mediaImagesIds.length === 0) {
                    alert("No media to download");
                    return;
                }

                var zip = new JSZip();
                var folder = zip.folder("case_media_" + vm.trCase.id);

                angular.forEach($scope.mediaImagesIds, function (media, index) {
                    if (media.base64) {
                        var binaryString = atob(media.base64);
                        var bytes = new Uint8Array(binaryString.length);
                        for (var i = 0; i < binaryString.length; i++) {
                            bytes[i] = binaryString.charCodeAt(i);
                        }
                        folder.file(media.imageName + ".png", bytes, { binary: true });
                    }
                });

                zip.generateAsync({ type: "blob" }).then(function (content) {
                    var link = document.createElement("a");
                    link.href = URL.createObjectURL(content);
                    link.download = "case_media_" + vm.trCase.id + ".zip";
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    URL.revokeObjectURL(link.href);
                });
            };
          vm.incUiPage = 1;
          vm.incPage = 0;
          vm.incItemsPerPage = 10;
          vm.incTotalItems = 0;
          vm.materialTxnList = [];
          vm.materialCumulativeList = []; 

          vm.showMaterial = function () {
            $("#caseMaterialModal").modal("show");

            vm.loadMaterialTransaction();
            vm.loadAllCumulativeData();
          };
          vm.loadMaterialTransaction = function () {
            $("#loading-bar-spinner").show();

            IncidentMaterial.getPage(
              { caseId: vm.trCase.id },
              vm.incPage,
              vm.incItemsPerPage,
              "last_modified_date,desc",
              function (data, headers) {
                vm.incTotalItems = headers("X-Total-Count");
                vm.materialTxnList = data || [];
               

                $("#loading-bar-spinner").hide();
              },
              function () {
                $("#loading-bar-spinner").hide();
              }
            );
          };
          vm.today = new Date();
          vm.cumItemsPerPage = 10;
          vm.loadAllCumulativeData = function () {
            console.log('hello');
            vm.cumPage = 0;
            vm.cumulativeData = [];
            vm._grouped = {};

            fetchPage();
          };
           function fetchPage() {
            geofenceMaterial.getCumulativeSummary(
              vm.trCase.geofences[0].id,
              vm.cumPage,
              vm.cumItemsPerPage,
              function (data) {
                if (!data || data.length === 0) {
                  finalizeGroupedData();
                  return;
                }
                data.forEach(function (item) {
                  var name = item.materialName;

                  if (!vm._grouped[name]) {
                    vm._grouped[name] = {
                      materialName: name,
                      REQUESTED: 0,
                      RECEIVED: 0,
                      UTILIZED: 0,
                      WASTAGE: 0,
                      RECOVERED: 0
                    };
                  }
                  var type = item.transactionType;
                  vm._grouped[name][type] += item.totalNoOfUnits || 0;
                });
                vm.cumPage++;
                fetchPage();
              }
            );
          }

          function finalizeGroupedData() {
            vm.cumulativeData = [];

            for (var key in vm._grouped) {
              var row = vm._grouped[key];
              row.STOCK = (row.REQUESTED || 0) + (row.RECOVERED || 0);
              vm.cumulativeData.push(row);
            }
          }

          vm.downloadCumulativeCSV = function () {
            if (!vm.cumulativeData || !vm.cumulativeData.length) {
              alert("No data to download");
              return;
            }
            var csv = "Till Date,Material Name,REQUESTED,RECEIVED,UTILIZED,WASTAGE,RECOVERED,STOCK\n";
            var formattedDate =
              vm.today.getFullYear() + "-" +
              (vm.today.getMonth() + 1) + "-" +
              vm.today.getDate();
            vm.cumulativeData.forEach(function (row) {
              csv +=
                formattedDate + ',' +
                '"' + row.materialName + '",' +
                row.REQUESTED + ',' +
                row.RECEIVED + ',' +
                row.UTILIZED + ',' +
                row.WASTAGE + ',' +
                row.RECOVERED + ',' +
                row.STOCK + "\n";
            });

            var blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
            var link = document.createElement("a");

            link.href = URL.createObjectURL(blob);
            link.download = vm.trCase.id+"_cumulative_report.csv";

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
          vm.incPageChanged = function () {
            vm.incPage = vm.incUiPage - 1;
            vm.loadMaterialTransaction();
          };
          vm.openDeleteMaterialModal = function (material, index) {
            vm.selectedMaterial = material;
            vm.selectedIndex = index;
            vm.deletefail = false;
            angular.element("#deleteModal").modal("show");
          };

          vm.confirmDeleteMaterial = function () {
            var payload = [vm.selectedMaterial.id];

            geofenceMaterial.deleteLogMtrlTx(payload).then(
              function () {
                angular.element("#deleteModal").modal("hide");
                vm.clearDelete();
                vm.loadMaterialTransaction();
                restoreParentModalScroll();
              },
              function () {
                vm.deletefail = true;
              }
            );
          };
          vm.clearDelete = function () {
            vm.selectedMaterial = null;
            vm.selectedInc = null;
            vm.selectedIndex = null;
            vm.deletefail = false;
          };
          vm.editMaterial = function (txn) {
            vm.editMaterialData = angular.copy(txn);
            vm.updating = false;
            angular.element("#editModal").modal("show");
          };
          vm.confirmEditMaterial = function () {
            vm.updating = true;
            var payload = [vm.editMaterialData];

            geofenceMaterial.updateLogMtrlTx(payload).then(
              function () {
                angular.element("#editModal").modal("hide");
                vm.clearEdit();
                vm.loadMaterialTransaction();
                restoreParentModalScroll();
              },
              function () {
                vm.updating = false;
              }
            );
          };
          vm.clearEdit = function () {
            vm.editMaterialData = null;
            vm.updating = false;
          };
          function restoreParentModalScroll() {
            angular.element("body").addClass("modal-open");
            angular.element("#caseMaterialModal").css("overflow-y", "auto");
          }


    }

    function myOption(zoom, center) {
			var myOptions;
			return (myOptions = {
				zoom: zoom,
				center: center,
				scaleControl: true,
				mapTypeId: google.maps.MapTypeId.ROADMAP,
				styles: [
					{
						featureType: "poi",
						elementType: "labels.icon",
						stylers: [
							{
								color: "#63666A",
							},
						],
					},
					{
						elementType: "labels.text.fill",
						stylers: [
							{
								color: "#63666A",
							},
						],
					} /* 
                    {
                        elementType: "geometry.fill",
                        stylers: [
                            {
                                color: "#EFEFEF",
                            },
                        ],
                    }, */,
					{
						featureType: "transit",
						elementType: "labels.icon",
						stylers: [
							{
								color: "#63666A",
							},
						],
					},
					{
						featureType: "road",
						elementType: "labels.icon",
						stylers: [{ visibility: "off" }],
					},
					{
						featureType: "landscape",
						stylers: [
							{
								color: "#efefef",
							},
						],
					},
					{
						featureType: "road.highway",
						elementType: "geometry",
						stylers: [
							{
								color: "#ffffff",
							},
						],
					}
				],
			});
		}
})();
